export const AVAILABLE_SIZES = ["P", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
export const SIMULATION_SIZES = ["P", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
export const MAGIC_FILL_EXCLUDED_SIZES = ["P", "4XL", "5XL"];

export const MFG_PRODUCT_STATUS_LABELS = {
  active: "Activo",
  obsolete: "Obsoleto",
};

export function magicFillQuantities(color, value, makeKey = (currentColor, size) => `${currentColor}::${size}`) {
  const qty = Math.max(0, Math.floor(Number(value || 0)));
  return Object.fromEntries(
    SIMULATION_SIZES.map((size) => [makeKey(color, size), MAGIC_FILL_EXCLUDED_SIZES.includes(size) ? 0 : qty])
  );
}

// Diseño, Patronaje y Producción se calculan a partir de sus checks.
// Validación sigue alternando Pendiente <-> Validado de forma independiente.
export const MFG_STAGE_STATE_META = {
  pending: { label: "Pendiente", className: "border-gray-300 bg-gray-50 text-gray-500" },
  in_progress: { label: "En proceso", className: "border-amber-300 bg-amber-100 text-amber-900" },
  done: { label: "Finalizado", className: "border-emerald-300 bg-emerald-100 text-emerald-900" },
  validated: { label: "Validado", className: "border-blue-300 bg-blue-100 text-blue-900" },
};

export const MFG_COST_SHEET_STAGES = [
  { id: "design", label: "Diseño", column: "design_status", cycle: [null, "in_progress", "done"] },
  { id: "pattern", label: "Patronaje", column: "pattern_status", cycle: [null, "in_progress", "done"] },
  { id: "production", label: "Producción", column: "production_status", cycle: [null, "in_progress", "done"] },
  { id: "validation", label: "Validación", column: "validation_status", cycle: [null, "validated"] },
];

export const MFG_COST_SHEET_VALIDATION_PASSWORD = "Ennage";

export function isCostSheetValidated(sheet) {
  return sheet?.validation_status === "validated";
}

export function nextStageValue(stage, currentValue) {
  const cycle = stage?.cycle || [null];
  const currentIndex = cycle.indexOf(currentValue ?? null);
  const nextIndex = (currentIndex + 1) % cycle.length;
  return cycle[nextIndex];
}

export function stageStateMeta(value) {
  return MFG_STAGE_STATE_META[value || "pending"] || MFG_STAGE_STATE_META.pending;
}
